import { CompanyEffects } from './company/company.effect';
import { StoreEffects } from './company-store/company-store.effect';
import { UserEffects } from './user/user.effect';

export const effects = [CompanyEffects, StoreEffects, UserEffects];
